import { render, staticRenderFns } from "./AccPixelSetup.vue?vue&type=template&id=7bfda424&scoped=true"
import script from "./AccPixelSetup.vue?vue&type=script&lang=js"
export * from "./AccPixelSetup.vue?vue&type=script&lang=js"
import style0 from "./AccPixelSetup.vue?vue&type=style&index=0&id=7bfda424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfda424",
  null
  
)

export default component.exports